module.exports = __webpack_public_path__ + "img/tips17.f295adb2.png";